export const cibHighly = ["32 32","<path d='M13.599 27.197h4.803v4.803h-4.803zM12 0h8v24h-8z'></path>"]